import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = { key: 0 };
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { storeToRefs } from 'pinia';
import { useRetroStore } from '@/pinia_stores/retro';
import { useSeatsValidations } from '@/composables/seatsValidations';
import EndOtherTurnDialog from '@/components/progress/dialogs/EndOtherTurnDialog.vue';
import EndTurnDialog from '@/components/progress/dialogs/EndTurnDialog.vue';
import InvitesAndSeatsModal from '@/components/workspaces/InvitesAndSeatsModal.vue';
import ShareLinkDialog from '@/components/ShareLinkDialog.vue';
import YourTurnDialog from '@/components/progress/dialogs/YourTurnDialog.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'FloatingContent',
    setup(__props) {
        const store = useStore();
        const retroStore = useRetroStore();
        const { isLoaded, phase, users, isInviteModalVisible, isOnlyModerator, loadingStatuses } = storeToRefs(retroStore);
        const { sendInvites } = retroStore;
        const workspace = computed(() => store.getters.workspace);
        const workspaceMembers = computed(() => workspace.value?.members || []);
        const invitableMembers = computed(() => {
            const inRetroIds = users.value.map((u) => u.id);
            const inRetroSet = new Set(inRetroIds);
            return workspaceMembers.value.filter((m) => !inRetroSet.has(m.id));
        });
        const inviteSelections = ref([]);
        const searchTerm = ref('');
        const seatsToBuy = ref(0);
        const isUpdatingSeats = ref(false);
        const isInvitesModalLoading = computed(() => isUpdatingSeats.value || loadingStatuses.value.has('invite'));
        const { hasToBuySeats } = useSeatsValidations({
            selectedUsers: inviteSelections,
            searchTerm,
            seatsToBuy,
            workspace
        });
        function handleCancelInvites() {
            isInviteModalVisible.value = false;
            inviteSelections.value = [];
        }
        const handleSendInvites = async () => {
            if (hasToBuySeats.value) {
                isUpdatingSeats.value = true;
                const totalSeats = workspace.value.seats + seatsToBuy.value;
                await store.dispatch('updateWorkspace', {
                    seats: totalSeats,
                    workspaceId: workspace.value.id
                });
                isUpdatingSeats.value = false;
            }
            sendInvites(inviteSelections.value);
            isInviteModalVisible.value = false;
            inviteSelections.value = [];
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (_unref(isLoaded))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        (_unref(isOnlyModerator) && _unref(phase) === 'setup')
                            ? (_openBlock(), _createBlock(ShareLinkDialog, { key: 0 }))
                            : _createCommentVNode("", true),
                        _createVNode(YourTurnDialog),
                        _createVNode(EndTurnDialog),
                        _createVNode(EndOtherTurnDialog)
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(InvitesAndSeatsModal, {
                    modelValue: inviteSelections.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((inviteSelections).value = $event)),
                    "search-term": searchTerm.value,
                    "onUpdate:search-term": _cache[1] || (_cache[1] = ($event) => ((searchTerm).value = $event)),
                    "seats-to-buy": seatsToBuy.value,
                    "onUpdate:seats-to-buy": _cache[2] || (_cache[2] = ($event) => ((seatsToBuy).value = $event)),
                    "allow-discard-search-on-cancel": "",
                    variant: "retro",
                    show: _unref(isInviteModalVisible),
                    users: _unref(invitableMembers),
                    workspace: _unref(workspace),
                    "is-loading": _unref(isInvitesModalLoading),
                    onCancel: handleCancelInvites,
                    onSend: handleSendInvites
                }, null, 8, ["modelValue", "search-term", "seats-to-buy", "show", "users", "workspace", "is-loading"])
            ], 64));
        };
    }
});
